import { ACTION_SNORT } from '../Action'
import { createDOM } from './DOMHelper'

export const getSpriteFromType = function (type) {
  const sprite = createDOM('ul', `action__timeline action__timeline--${type}`)
  const expandLayer = createDOM('li', `action__timeline__expand`)
  const growLayer1 = createDOM('li', `action__timeline__grow action__timeline__grow--1`)
  const growLayer2 = createDOM('li', `action__timeline__grow action__timeline__grow--2`)
  const growLayer3 = createDOM('li', `action__timeline__grow action__timeline__grow--3`)
  sprite.appendChild(expandLayer)
  sprite.appendChild(growLayer1)
  sprite.appendChild(growLayer2)
  sprite.appendChild(growLayer3)
  sprite.updateRatio = ratio => {
    expandLayer.style.width = type === ACTION_SNORT ? `${(1-ratio) * 100}%` : `${ratio * 100}%`
    growLayer1.style.transform = `scaleY(${Math.pow(ratio, 2)})`
    growLayer2.style.transform = `scaleY(${Math.pow(ratio, 4)})`
    growLayer3.style.transform = `scaleY(${Math.pow(ratio, 6)})`
  }
  return sprite
}


// WEBPACK FOOTER //
// ./src/scripts/helpers/ActionHelper.js